(function() { window.GUID_6ca7e2e9_c6bc_471e_8241_71b0c9b9aa6a = { getGuid: function() { return "6ca7e2e9-c6bc-471e-8241-71b0c9b9aa6a"; } }; })();
var CompuSport;
(function (CompuSport) {
    var ContextControls;
    (function (ContextControls) {
        class ScoreSheetSelectionBehaviorHelper {
            GetSelectedScoreSheetId() {
                return this.scoreSheetDropDown.GetSelectedItemValue("value");
            }
            constructor($context, onEncounterTypeChange) {
                let existingValue = $('#ScoreSheetSelectionBehaviorData').data('val');
                this.refreshUI(existingValue);
                this.onEncounterTypeChangeCallback = onEncounterTypeChange;
                this.scoreSheetDropDown = $context.find('#EncounterTypeId').control();
                this.scoreSheetDropDown.SelectionChange = () => {
                    this.onEncounterTypeChange();
                };
                let $showWinBoxCheckbox = $context.find('#ShowWinBoxInScoreSheet');
                let $showScoreBoxCheckbox = $context.find('#ShowScoreBoxInScoreSheet');
                $showWinBoxCheckbox.offon('change.behavior', () => {
                    this.onEncounterTypeChange();
                });
                $showScoreBoxCheckbox.offon('change.behavior', () => {
                    this.onEncounterTypeChange();
                });
            }
            onEncounterTypeChange() {
                if (this.onEncounterTypeChangeCallback != null)
                    this.onEncounterTypeChangeCallback(this.GetSelectedScoreSheetId());
                this.getDataFromController((response) => {
                    this.refreshUI(response);
                });
            }
            getDataFromController(callback) {
                var data = {
                    sportEventId: CSParameters.SportEventId,
                    encounterTypeId: this.GetSelectedScoreSheetId()
                };
                CompuSport.Ajax.Get(CSParameters.RUrl + "ScoreSheetSelectionBehaviorHelper/GetData/", data, (response) => {
                    this.refreshUI(response);
                });
            }
            refreshUI(data) {
                if (data != null) {
                    this.overridesValuesFromResultsToInput(data);
                    this.hideShowElements(data.HasScoreBoxes, () => this.GetHasScoreBoxesElements());
                    this.hideShowElements(data.HasWinBoxes, () => this.GetHasWinBoxesElements());
                    this.hideShowElements(data.HasFlawlessBox || data.HasFlawlessList, () => this.GetHasFlawlessElements());
                    this.hideShowElements(data.GameRowsAreDynamic, () => this.GetGameRowsAreDynamicElements());
                    this.hideShowElements(data.HasHandicap, () => this.GetHasHandicapElements());
                    this.hideShowElements(data.HasRoundPoint, () => this.GetHasRoundPointsElements());
                    this.hideShowGamePerGameWarning(data.NeedsGamePerGame);
                }
            }
            overridesValuesFromResultsToInput(data) {
                if (data.GameRowsAreDynamic) {
                    if (data.HasWinBoxes && !$('#ShowWinBoxInScoreSheet').is(":checked")) {
                        data.HasWinBoxes = false;
                    }
                    if (data.HasScoreBoxes && !$('#ShowScoreBoxInScoreSheet').is(":checked")) {
                        data.HasScoreBoxes = false;
                    }
                }
                if (data.HasManyRaceTo) {
                    $("#MethodCalcRoundTotal").control()
                        .SetValue({ value: "RACETORACETO" });
                }
            }
            hideShowElements(show, method) {
                $.each(method(), (index, element) => {
                    if (show)
                        $(element).show();
                    else
                        $(element).hide();
                });
            }
            hideShowGamePerGameWarning(show) {
                if (show) {
                    $('.needs-game-per-game-to-show').show();
                    $('.needs-game-per-game-to-hide').hide();
                    //$('#AutoHdcpCalcMethod').parent().hide();
                }
                else {
                    $('.needs-game-per-game-to-show').hide();
                    $('.needs-game-per-game-to-hide').show();
                    //$('#AutoHdcpCalcMethod').parent().show();
                }
            }
            GetHasWinBoxesElements() {
                let list = new Array();
                return list;
            }
            GetHasScoreBoxesElements() {
                let list = new Array();
                list.push($('#AutoOpponentScoreActivated').parents('.CSInput'));
                list.push($('#AutoOpponentScore').parents('.CSInput'));
                list.push($('#BalanceOpponentScoreActivated').parents('.CSInput'));
                list.push($('#NbrPtsMax').parents('.CSInput'));
                list.push($('#ValidateOpponentScore').parents('.CSInput'));
                return list;
            }
            GetHasFlawlessElements() {
                let list = new Array();
                list.push($('#AvailableFlawlessValues').parents('.CSInput'));
                return list;
            }
            GetHasHandicapElements() {
                let list = new Array();
                list.push($('.has-handicap-visibility'));
                return list;
            }
            GetHasRoundPointsElements() {
                let list = new Array();
                list.push($('.has-roundpoints-visibility'));
                return list;
            }
            GetGameRowsAreDynamicElements() {
                let list = new Array();
                list.push($('#DataToInputTouchScreenNote'));
                list.push($('#MethodCalcRoundTotal').parents('.CSInput'));
                list.push($('#ShowScoreBoxInScoreSheet').parents('.CSInput'));
                list.push($('#ShowWinBoxInScoreSheet').parents('.CSInput'));
                return list;
            }
        }
        ContextControls.ScoreSheetSelectionBehaviorHelper = ScoreSheetSelectionBehaviorHelper;
    })(ContextControls = CompuSport.ContextControls || (CompuSport.ContextControls = {}));
})(CompuSport || (CompuSport = {}));

//# sourceMappingURL=ScoreSheetSelectionBehaviorHelper.js.map
